import React from "react";
import styles from "./FaqSection.module.css";
import { motion } from "framer-motion";

const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.13,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: -30 },
  show: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 60, damping: 18 },
  },
};

const FaqSection = ({ FAQ_DATA, faqOpenIndex, handleFaqToggle }) => {
  // Generate FAQPage structured data
  const faqStructuredData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQ_DATA.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };
  return (
    <>
      <section className={"faqSection container"}>
        <h2 className={styles.faqTitle}>Frequently Asked Questions</h2>
        <motion.div
          className={styles.faqList}
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
        >
          {FAQ_DATA.map((item, idx) => (
            <motion.div
              key={item.question}
              className={styles.faqItem}
              variants={itemVariants}
            >
              <button
                className={styles.faqQuestion}
                onClick={() => handleFaqToggle(idx)}
                aria-expanded={faqOpenIndex === idx}
                aria-controls={`faq-panel-${idx}`}
              >
                <span>{item.question}</span>
                <span className={styles.faqIcon}>
                  {faqOpenIndex === idx ? "−" : "+"}
                </span>
              </button>
              {faqOpenIndex === idx && (
                <div
                  id={`faq-panel-${idx}`}
                  className={styles.faqAnswer}
                  role="region"
                  aria-labelledby={`faq-question-${idx}`}
                >
                  {item.answer}
                </div>
              )}
            </motion.div>
          ))}
        </motion.div>
      </section>
      <script type="application/ld+json">
        {JSON.stringify(faqStructuredData)}
      </script>
    </>
  );
};

export default FaqSection;
